import React from 'react';
import { CtaButton } from './CtaButton';
import { ProductStack } from './ProductStack';
import { coaches } from '../data/coaches';
const chips = ['6 Volumes · 300 pages', '5 Bonuses', '59 Ready-Run Sessions', '29 Worksheets', 'Kids · Teens · Rec groups', 'No-gear & low-gear options'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Pick it, print it, run it'];

/**
 * Proof line under the CTA. Swap for a real rating + buyer count
 * (e.g. "4.9/5 from 300+ coaches") once you have verified reviews.
 */
const PROOF_LINE = <>
    Built for <span className="font-bold text-white" data-id="element-112" data-mp="sb1cvtp1w785">parkour coaches &amp; instructors</span>{' '}
    running gym programs, after-school clubs, PE and camps
  </>;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-navy-deep" data-id="element-113" data-mp="3d1ii934hv0k9">
      <div className="relative mx-auto w-full max-w-6xl px-4 pb-12 pt-5 sm:px-5 sm:pb-16 lg:pb-20 lg:pt-10" data-id="element-114" data-mp="3czfkty10i55i">
        <div className="grid gap-7 lg:grid-cols-[1.02fr_.98fr] lg:items-center lg:gap-14" data-id="element-115" data-mp="384s78u7jqv5p">
          <div className="lg:col-start-1 lg:row-start-1" data-id="element-116" data-mp="3j6fx1mlet7c9">
            <p className="text-xs font-semibold text-concrete sm:text-sm" data-id="element-117" data-mp="3o6khtotcoo8a">
              The Parkour Class-Ready Megapack · for parkour coaches &amp; instructors
            </p>
            <h1 className="mt-3 font-display text-[34px] font-bold text-white sm:text-5xl lg:text-[56px] xl:text-6xl" data-id="element-118" data-mp="3e8wjkowjcyld">
              Your next parkour class is{' '}
              <span className="mark-slash" data-id="element-119" data-mp="30g6lhm3qg37w">
                <span data-id="element-120" data-mp="358zoo5jjz3hv">ready to run.</span>
              </span>
            </h1>
          </div>

          <div className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-121" data-mp="2qkmsp8kgtknd">
            <ProductStack className="max-w-[640px] lg:max-w-none" data-id="element-122" data-mp="2vieuqvetqn5a" />
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-123" data-mp="2hj5clq725iyo">
            <p className="max-w-xl text-[15px] leading-relaxed text-white/75 sm:text-base lg:text-lg" data-id="element-124" data-mp="2hjox9eo3elge">
              59 complete class plans for kids, teens and rec groups — each one a
              warm-up, a skill with a built-in easier version, a game that kills
              waiting time, and a cool-down. From first landings to vaults, jumps,
              walls and flow, plus the system to run big groups and mixed levels.
              Never plan a parkour class from scratch again: pick today&apos;s
              session, walk in, teach.
            </p>

            <ul className="mt-5 flex flex-wrap gap-1.5 sm:gap-2" data-id="element-125" data-mp="1b15o7bpztrnf">
              {chips.map(chip => <li key={chip} className="rounded-full border border-navy-line px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-white/70 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-126" data-mp="162uer23m1j5q">
                  {chip}
                </li>)}
            </ul>

            <div className="mt-7 w-full max-w-md lg:mx-0" data-id="element-127" data-mp="3ltqgvowuphzb">
              <CtaButton data-id="element-128" data-mp="3hqu1s86is404">Get the Class-Ready Megapack</CtaButton>
            </div>

            <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-129" data-mp="1x9b590wn91ck">
              <ul className="flex -space-x-2.5" data-id="element-130" data-mp="1x7hy7ki4cf41">
                {coaches.map((coach, i) => <li key={`${coach.name}-${i}`} data-id="element-131" data-mp="218jubsgqob1s" data-mpi={i}>
                    <img src={coach.avatar} alt={coach.name} width={40} height={40} loading="lazy" className="h-9 w-9 rounded-full border-2 border-navy-deep object-cover sm:h-10 sm:w-10" data-id="element-132" data-mp="268y3jdu2tr1e" />
                  </li>)}
              </ul>
              <p className="max-w-sm text-xs leading-relaxed text-white/65" data-id="element-133" data-mp="2p1jv3lxyavg6">
                {PROOF_LINE}
              </p>
            </div>

            <ul className="mt-5 grid gap-2 text-xs text-white/60 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-134" data-mp="2tx7nsbbn66qf">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-135" data-mp="zkr8kl0vbi9f">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-136" data-mp="4bdxli20sdpo" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}